export function computeDiffForCohortBuilderItem(
  obj1: Record<string, any>,
  obj2: Record<string, any>,
  ignoreKeys: string[] = ['id', 'changeStatus', 'changedBy', 'dirty', 'updated']
) {
  function deepCompare(a: Record<string, any>, b: Record<string, any>) {
    if (a === b) return false;

    if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
      return a !== b;
    }

    const keysA = Object.keys(a).filter((k) => !ignoreKeys.includes(k));
    const keysB = Object.keys(b).filter((k) => !ignoreKeys.includes(k));

    if (keysA.length !== keysB.length) return true;

    for (const key of keysA) {
      if (!keysB.includes(key)) return true;

      if (deepCompare(a[key], b[key])) return true;
    }

    return false;
  }

  return deepCompare(obj1, obj2);
}
